module.exports = __webpack_public_path__ + "img/night-city-1.6313ec2b.jpg";